import React, { useMemo } from 'react'
import { BioInfoContainer, FormInfoWrapper } from './style'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../redux/store';
import { formatDateWithoutTime, getBmiCategoryText } from '../../../../helpers';

const BioInfo = () => {
  const { selectedClient } = useSelector((state: RootState) => state.professionals);
  const weight = selectedClient?.bio?.weight || 0;
  const heightCm = selectedClient?.bio?.length || 0;
  const waistCircumference = selectedClient?.bio?.waistCircumference || 0;
  const heightM = heightCm / 100;

  const waisToHeightRatio = useMemo(() => {
    return heightCm ? (waistCircumference / heightCm).toFixed(2) : 'N/A';
  }, [heightCm, waistCircumference]);

  const bmi = useMemo(() => {
    return heightM ? (weight / (heightM * heightM)).toFixed(2) : 'N/A';
  }, [heightM, weight]);

  return (
    <BioInfoContainer>
      <FormInfoWrapper>
        <div>First name</div>
        <div>{selectedClient?.firstName}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Family name</div>
        <div>{selectedClient?.familyName}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Sex</div>
        <div style={{ textTransform: 'capitalize' }}>{selectedClient?.bio?.sex}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Date of birth</div>
        <div>{formatDateWithoutTime(selectedClient?.bio?.dateOfBirth as string)}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Weight (kg)</div>
        <div>{selectedClient?.bio?.weight}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Waist circumference (cm)</div>
        <div>{selectedClient?.bio?.waistCircumference}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Your Body Mass Index (BMI)</div>
        <div>{`${bmi} (${bmi !== 'N/A' ? getBmiCategoryText(parseInt(bmi)) : ''})`}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Waist to height ratio</div>
        <div>{waisToHeightRatio}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Height (cm)</div>
        <div>{selectedClient?.bio?.length}</div>
      </FormInfoWrapper>
      <FormInfoWrapper>
        <div>Vegetarian</div>
        <div>{selectedClient?.bio?.isVegetarian ? 'Yes' : 'No'}</div>
      </FormInfoWrapper>
    </BioInfoContainer>
  )
}

export default BioInfo